import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TicketSourceSubtype } from '../enums/ticket-source-subtype.enum';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'ticketSourceSubtype',
})
export class TicketSourceSubtypePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(sourceSubtype: TicketSourceSubtype): string {
        switch (sourceSubtype) {
            case TicketSourceSubtype.none:
                return this.translateService.instant('All');
            case TicketSourceSubtype.post:
                return this.translateService.instant('Post');
            case TicketSourceSubtype.postedByTeam:
                return this.translateService.instant('Posted by team');
            case TicketSourceSubtype.directMessage:
                return this.translateService.instant('Direct message');
            case TicketSourceSubtype.mention:
                return this.translateService.instant('Mention');
            case TicketSourceSubtype.external:
                return this.translateService.instant('External');
            case TicketSourceSubtype.internal:
                return this.translateService.instant('Internal');
            case TicketSourceSubtype.forward:
                return this.translateService.instant('Forward');
            default:
                return this.translateService.instant('Unknown');
        }
    }
}
